import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from '../../../../store/middleware/apiActions';
import { peopleUpdated, peopleDeleted } from './people';

const slice = createSlice({
	name: 'person',
	initialState: { loading: false, data: null, profileUpdated: false },
	reducers: {
		savingProfile: (person, action) => {
			person.loading = true;
		},
		personSaved: (person, action) => {
			person.loading = false;
			person.profileUpdated = true;
		},
		personReceived: (person, action) => {
			person.loading = false;
			person.data = action.payload;
		},
		profileUpdated: (person, action) => {
			person.profileUpdated = false;
		},
		personReseted: () => null,
		personCreated: {
			reducer: (person, action) => action.payload,
			prepare: event => ({
				payload: {
					loading: true,
					data: {
						first_name: '',
						last_name: '',
						role: '',
						email: '',
						date_of_birth: '',
						phone: '',
						state: '',
						city: '',
						postal_code: '',
						citizenship: '',
						legal_status: '',
						status_expiration_date: '',
						years_in_canada: 0,
						employer_name: '',
						employment_type: '',
						monthly_income: 0.0,
						job_title: '',
						lead_source: '',
						banks: '',
						address: '',
						avatar_url: '',
						login_network: '',
						status: '',
						life_cycle: '',
						tour_done: false,
						created_at: new Date(),
						updated_at: new Date(),
						last_login: '',
						auth_id: '',
						hammurabi_preferences: {},
						loans: [],
						manages: [],
						proposals: [],
						payments: [],
						legal_docs: [],
						transactions: [],
						income_range: '',
					},
				},
			}),
		},
	},
});

export const getPerson = personId => (dispatch, getState) => {
	dispatch(
		apiCallBegan({
			api: 'hammurabi',
			url: `/people/${personId}`,
			method: 'GET',
			onSuccess: personReceived.type,
		})
	);
};

export const deleteperson = personId => (dispatch, getState) => {
	dispatch(
		apiCallBegan({
			api: 'person',
			url: `/people/${personId}`,
			method: 'DELETE',
			onSuccess: peopleDeleted.type,
		})
	);
};

export const updatedPerson = person => (dispatch, getState) => {
	dispatch(personReceived(person));
	dispatch(personSaved());
	dispatch(peopleUpdated(person));
};

export const profileIncomplete = person => {
	if (!person) return true;
	let test = false;
	if (person.first_name === '' || person.first_name === null) test = true;
	if (person.last_name === '' || person.last_name === null) test = true;
	// if (person.date_of_birth === "" || person.date_of_birth === null)
	//     test = true;
	if (person.phone === '' || person.phone === null) test = true;
	if (person.state === '' || person.state === null) test = true;
	if (person.city === '' || person.city === null) test = true;
	if (person.postal_code === '' || person.postal_code === null) test = true;
	if (person.citizenship === '' || person.citizenship === null) test = true;
	if (person.legal_status === '' || person.legal_status === null) test = true;
	// if (
	//     person.status_expiration_date === "" ||
	//     person.status_expiration_date === null
	// )
	// test = true;
	if (person.employer_name === '' || person.employer_name === null) test = true;
	if (person.employment_type === '' || person.employment_type === null) test = true;
	if (person.income_range === 0 || person.income_range === null) test = true;
	if (person.job_title === '' || person.job_title === null) test = true;
	// if (person.banks === "" || person.banks === null) test = true;
	if (person.address === '' || person.address === null) test = true;
	return test;
};

export const canRequestLoan = person => {};

export const getLoansAndProposals = person => {};

export const { personCreated, peopleSaved, personReceived, personReseted, savingProfile, profileUpdated, personSaved } =
	slice.actions;

export const savePerson =
	(person, toast = '') =>
	(dispatch, getState) => {
		let method = 'PUT';
		let url = `/people/${person.id}`;

		delete person.id;

		let onSuccess = updatedPerson;

		person.updated_at = new Date();
		Object.keys(person).forEach(x => {
			person[x] === null && delete person[x];
		});

		delete person.loans;
		delete person.manages;
		delete person.proposals;
		delete person.payments;
		delete person.legal_docs;
		delete person.transactions;

		dispatch(
			apiCallBegan({
				api: 'hammurabi',
				url,
				method,
				data: person,
				onSuccess,
				onStart: savingProfile.type,
				toastNotification: toast,
			})
		);
	};

export default slice.reducer;
